var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AEEA93",
    d: "M52.328 13.084a1.133 1.133 0 1 1 0 2.266 1.133 1.133 0 0 1 0-2.266M52.328 42.537a1.133 1.133 0 1 1 0 2.267 1.133 1.133 0 0 1 0-2.267M46.664 49.334a2.265 2.265 0 1 1 .001 4.53 2.265 2.265 0 0 1 0-4.53M44.398 2.889a1.133 1.133 0 1 1 0 2.266 1.133 1.133 0 0 1 0-2.266"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#64BE3C",
    d: "M28.54 6.287c-12.514 0-22.657 10.143-22.657 22.656S16.026 51.6 28.539 51.6s22.656-10.144 22.656-22.657S41.052 6.287 28.54 6.287"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.54 45.936c-9.385 0-16.993-7.608-16.993-16.993s7.608-16.992 16.992-16.992 16.992 7.608 16.992 16.992-7.608 16.992-16.992 16.992"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#64BE3C",
    d: "M36.961 23.588a2.265 2.265 0 0 1 0 3.203l-8.01 8.012-3.203 3.203-3.205-3.203-2.403-2.404a2.26 2.26 0 0 1-.663-1.602 2.265 2.265 0 0 1 3.867-1.602l2.404 2.403 8.01-8.01a2.26 2.26 0 0 1 3.203 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEEA93",
    d: "M11.547 51.6a1.133 1.133 0 1 1 0 2.266 1.133 1.133 0 0 1 0-2.266M8.715 5.154a2.832 2.832 0 1 1 0 5.664 2.832 2.832 0 0 1 0-5.664M4.75 14.217a1.133 1.133 0 1 1 0 2.266 1.133 1.133 0 0 1 0-2.266M4.75 42.537a1.133 1.133 0 1 1 0 2.267 1.133 1.133 0 0 1 0-2.267"
  })));
};
export default SvgSuccess;